<template>
  <v-menu open-on-hover top :offset-y="true">
    <template v-slot:activator="{ on }">
      <v-chip class="mr-1 pl-0 white--text" :class="onlyavatar ? 'pr-0 mr-0' : ''" small
        :close-icon="closeable ? closeable : 'mdi-close'" :close="closeable != undefined && closeable != false"
        :color="baseColor + ' lighten-' + number" @click:close="$emit('Close')" v-on="on">
        <avatar :color="baseColor + ' ' + avatarcolorvariant" :fullname="user.Name" :small="true"
          :class="onlyavatar ? '' : 'mr-1'">
        </avatar>
        {{ !onlyavatar ? user.Name : '' }}
      </v-chip>
    </template>

    <!-- v-menu content -->
    <v-container class="pa-0">
      <v-card width="200" class="d-flex flex-column pt-4">
        <avatar :color="baseColor + ' ' + avatarcolorvariant" :fullname="user.Name" :large="true"
          class="align-self-center">
        </avatar>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="d-flex justify-center">
              {{ user.Name ? user.Name : 'Unnamed user' }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="user.EmailAdress" class="d-flex">
              <v-icon size="17" class="mr-3">{{ getUserTypeIcon(user.UserTypeId) }}</v-icon>
              {{ getUserTypeName(user.UserTypeId) }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="user.EmailAdress" class="d-flex">
              <v-icon size="17" class="mr-3">mdi-email</v-icon>
              {{ user.EmailAdress }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="user.Mobile" class="d-flex">
              <v-icon size="17" class="mr-3">mdi-phone</v-icon>
              {{ user.Mobile }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <!-- 
        <v-divider></v-divider>
        <v-btn @click="viewFullUser(user.Id)" class="linkStyleButton">
          {{ $t('servicesystem.common_objects.document.open_in_new_tab') }}
          <v-icon size="13" class="pl-2">mdi-open-in-new</v-icon>
        </v-btn>
        -->
      </v-card>
    </v-container>
  </v-menu>
</template>

<script>
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";
import Avatar from "@/components/Buttons/Avatar.vue";

export default {
  name: "UserChip",
  props: ["user", "index", "typecolored", "closeable", "color", "nowave", "onlyavatar"],
  components: { Avatar },
  mixins: [UserTypeMixin],

  data() {
    return {};
  },

  mounted() {

  },

  methods: {
    viewFullUser(id) {
      this.$router.push({ name: "ViewUser", params: { userId: id } });
    },
  },

  computed: {
    baseColor() {
      var color = 'primary' //(this.user.Id == this.userInfo.Id) ? 'red' : "primary";
      if (this.color) {
        color = this.color;
      }
      else if (color != 'red' && this.typecolored) {
        color = this.getUserTypeColor(this.user.UserTypeId)
      }
      return color;
    },

    avatarcolorvariant() {
      return this.nowave ? "darken-1" : this.number < 1 ? "darken-1" : "lighten-" + (this.number - 1);
    },

    avatartext() {
      return this.user[0] + this.user[1];
    },

    number() {
      var limit = 2;
      var wavenumber = this.index % (limit * 2);
      wavenumber = wavenumber < limit ? wavenumber : limit - (wavenumber % limit);

      return this.nowave ? 0 : wavenumber;
    },
  },

  watch: {},
};
</script>

<style lang="scss"></style>